import { useState, useEffect } from "react";
import { db } from "services/firebaseConfig";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { checkHoliday } from "services/holidayService";

export const usePendingAlerts = (userRole) => {
  const [alerts, setAlerts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Apenas admin ou editor devem ver o alerta
    if (userRole !== "admin" && userRole !== "editor") {
      setAlerts([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    // Pegamos o início do dia atual para evitar alertas de dias já passados
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const q = query(
      collection(db, "excursions"),
      where("status", "==", "Agendado"),
      where("excursionDate", ">=", today)
    );

    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const fetchedAlerts = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const excursionDate = data.excursionDate?.toDate();
          
          if (!excursionDate) return;

          const isCombo = data.comboIncluded === true;
          // Dia da semana: 0 = Domingo, 1 = Seg, 2 = Ter, 3 = Qua, 4 = Qui, 5 = Sex, 6 = Sab
          const dayOfWeek = excursionDate.getDay();
          let isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
          const holidayName = checkHoliday(excursionDate);

          if (holidayName) {
            isWeekday = false;
          }

          // Regra: se é dia de semana OU tem pacote (Combo)
          if (isWeekday || isCombo) {
            let reason = "Contém pacote especial";
            if (isWeekday && isCombo) {
              reason = "Dia de semana com pacote";
            } else if (isWeekday) {
              reason = "Dia de semana";
            } else if (holidayName && isCombo) {
              reason = `Feriado (${holidayName}) com pacote`;
            }

            fetchedAlerts.push({
              id: doc.id,
              ...data,
              excursionDate,
              reason,
            });
          }
        });

        // Ordenar por data mais próxima primeiro
        fetchedAlerts.sort((a, b) => a.excursionDate.getTime() - b.excursionDate.getTime());
        
        setAlerts(fetchedAlerts);
        setIsLoading(false);
      },
      (err) => {
        console.error("Erro ao buscar alertas de excursões:", err);
        setError("Erro ao carregar alertas.");
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, [userRole]);

  return { alerts, isLoading, error };
};
